var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgView = function SvgView(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.41748C7.81867 2.41748 6.04395 4.19221 6.04395 6.37354C6.04395 8.55487 7.81867 10.3296 10 10.3296C12.1813 10.3296 13.9561 8.55487 13.9561 6.37354C13.9561 4.19221 12.1813 2.41748 10 2.41748ZM10 9.01089C8.5457 9.01089 7.36266 7.8278 7.36266 6.37354C7.36266 4.91928 8.54574 3.73619 10 3.73619C11.4543 3.73619 12.6373 4.91928 12.6373 6.37354C12.6373 7.8278 11.4543 9.01089 10 9.01089Z",
    fill: "#007BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8729 5.98462C19.6942 5.74021 15.4371 0 9.9999 0C4.56274 0 0.305391 5.74021 0.126914 5.98439C-0.0423048 6.21626 -0.0423048 6.53076 0.126914 6.76263C0.305391 7.00705 4.56274 12.7473 9.9999 12.7473C15.4371 12.7473 19.6942 7.00701 19.8729 6.76283C20.0423 6.53099 20.0423 6.21626 19.8729 5.98462ZM9.9999 11.4286C5.99486 11.4286 2.52606 7.61869 1.49922 6.37318C2.52473 5.12657 5.98626 1.31867 9.9999 1.31867C14.0048 1.31867 17.4733 5.1279 18.5006 6.37407C17.4751 7.62064 14.0135 11.4286 9.9999 11.4286Z",
    fill: "#007BFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view.111520eb.svg";
export { ForwardRef as ReactComponent };